import React, { Component } from 'react';
import ReactTable from 'react-table';
import { matchSorter } from 'match-sorter';
import 'react-table/react-table.css';

export default class ProductListTable extends Component {
  render() {
    return (
      <ReactTable
        data={this.props.data}
        filterable
        defaultPageSize={20}
        className="-striped -highlight"
        defaultSorted={[{ id: 'ProductCode', desc: false }]}
        columns={[
          {
            Header: 'Product Code',
            accessor: 'ProductCode',
            filterAll: true,
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, { keys: ['ProductCode'] }),
          },
          {
            Header: 'Model',
            accessor: 'Model',
            filterAll: true,
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, { keys: ['Model'] }),
          },
          { Header: 'Color', accessor: 'Color' },
          { Header: 'Voltage', accessor: 'Voltage' },
          { Header: 'HDD', accessor: 'HDD' },
          { Header: 'SSD', accessor: 'SSD' },
          {
            Header: 'SKU',
            accessor: 'sku',
            filterAll: true,
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, { keys: ['sku'] }),
          },
          { Header: 'Item', accessor: 'Item' },
        ]}
      />
    );
  }
}
